module.exports = __webpack_public_path__ + "static/media/Maroon 5.f8e609d2.jpg";